import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import type { ServiceLink } from "../../common/Header/types";
import { useRestoreApp } from "../../features/Auth/hooks/use-restore-app";
import {
  selectIsUserInfoLoading,
  selectUserInfo,
} from "../../features/Auth/redux/selectors";
import { LoginPage } from "../../pages/LoginPage";
import { useAppSelector } from "../../services/redux/hooks/use-selector";
import { RenderRoutes } from "./Components/RenderRoutes";
import { routesArray } from "./routes";
import { extraAppsPageRouteConfig } from "./routes/extraApp/config";
import { notFoundPageRouteConfig } from "./routes/not-found/config";
import { userfilesPageRouteConfig } from "./routes/userfiles/config";
import { agentsPageRouteConfig } from "./routes/agents/config";
import { pollsRouteConfig } from "./routes/polls/config";

export const AppRouting = () => {
  const userInfo = useAppSelector(selectUserInfo);
  const isLoading = useAppSelector(selectIsUserInfoLoading);
  const { isApiCreated, recreateApi, restoreApp } = useRestoreApp();

  useEffect(() => {
    recreateApi();
  }, [isApiCreated]);

  useEffect(() => {
    restoreApp();
  }, [isApiCreated]);

  if (isLoading) {
    return <CircularProgress color="success" />;
  }

  if (!userInfo) {
    return <LoginPage />;
  }

  const filteredChildren = routesArray.children
    ?.filter((route) =>
      userInfo["user-groups"]?.includes(route.path as ServiceLink),
    )
    .concat(notFoundPageRouteConfig)
    .concat(userfilesPageRouteConfig);

  const routeConfig = {
    ...routesArray,
    children: filteredChildren,
  };

  return <RenderRoutes routes={[routeConfig]} />;
};
